import React from 'react'

import s from './styles.module.scss'

import IconSvg from '../../../../../../atoms/icons/icon-svg/IconSvg'

const TagNabooPack = () => {
  return (
    <div className={s.container}>
      <IconSvg.Lock className={s.lockIcon} color='grey' />
      <p className={s.label}>Pack Naboo</p>
    </div>
  )
}

export default TagNabooPack
